module.exports = __webpack_public_path__ + "static/media/EmptyState.d17948d6.svg";